import { useDetailsScreen } from '@/features/dashboard/bookingChanges/contexts/DetailsContext.ts';
import useGetChangeHistory from '@/features/dashboard/bookingChanges/hooks/useGetChangeHistory.ts';
import useWithdrawalJustifications from '@/features/dashboard/bookingChanges/hooks/useWithdrawalJustifications.ts';
import {
  ChangeHistoryTable,
  ChangeHistoryTableSkeleton,
} from '@/features/dashboard/bookingChanges/components/history';

/** Zakładka „Historia” ekranu rezerwacji — paczki, które już weszły w życie. */
const ChangeHistoryTab = () => {
  const { bookingId } = useDetailsScreen();
  const historyQuery = useGetChangeHistory(bookingId);
  const packages = historyQuery.data ?? [];
  const justifications = useWithdrawalJustifications(bookingId, packages);

  if (historyQuery.isLoading) {
    return <ChangeHistoryTableSkeleton />;
  }

  return (
    <ChangeHistoryTable packages={packages} justifications={justifications} />
  );
};

export default ChangeHistoryTab;
